import Splide from "@splidejs/splide";

window.addEventListener('DOMContentLoaded', function () {
    const initializedSliders = new Map();

    function initSplideSlider(element, direction = "") {
        if (!element) return;

        if (initializedSliders.has(element)) {
            const existingSplide = initializedSliders.get(element);
            if (direction) existingSplide.go(direction);
            return;
        }

        const splide = new Splide(element, {
            type: 'slide',
            perPage: 1,
            arrows: false,
            pagination: true,
            drag: false,
            lazyLoad: "sequential",
            breakpoints: {
                800: {
                    drag: true,
                },
            },
        }).mount();

        const pagination = splide.root.querySelector(".splide__pagination");
        const wrapper = document.createElement('div');
        wrapper.classList.add("splide_pagination_wrapper");
        if (pagination) {
            pagination?.parentNode?.insertBefore(wrapper, pagination);
            wrapper.appendChild(pagination);
        }

        const totalSlides = splide.length;
        const maxVisibleDots = 5;
        const dotWidthWithMargin = 15;

        function updatePagination(currentIndex) {
            const dots = pagination.children;

            for (let i = 0; i < dots.length; i++) {
                dots[i].classList.toggle('active', i === currentIndex);
            }

            let windowStart = Math.max(0, currentIndex - Math.floor(maxVisibleDots / 2));
            let windowEnd = windowStart + maxVisibleDots;

            if (windowEnd > totalSlides) {
                windowEnd = totalSlides;
                windowStart = Math.max(0, windowEnd - maxVisibleDots);
            }

            const offset = windowStart * dotWidthWithMargin;
            pagination.style.transform = `translateX(-${offset}px)`;
        }

        splide.on("move", (i) => {
            updatePagination(i);

            if (splide.imagesLoaded) return;

            const advertId = element.getAttribute("data-advert-id");
            const imageCount = element.getAttribute("data-image-count");

            if (!(imageCount > 1)) return;

            fetch(`https://choosemycar.com/api/adverts/${advertId}/images`, {
                headers: {
                    'Accept': 'application/vnd.api+json',
                    'Content-Type': 'application/vnd.api+json',
                }
            })
                .then((res) => res.json())
                .then(({data, errors}) => {
                    if (errors) return;

                    const images = data?.map((item) => item.attributes.medium);

                    splide.Components.Slides.forEach(({slide}, i) => {
                        if (i === 0) return;

                        const img = slide.querySelector("img");
                        if (!img.getAttribute("src")) {
                            img.setAttribute("data-splide-lazy", images[i]);
                            img.parentElement.classList.add("loaded");
                        }
                    });
                    splide.refresh();
                    splide.imagesLoaded = true;
                });

            element.querySelector(".tmp_pagination")?.remove();
        });

        if (direction) splide.go(direction);
        initializedSliders.set(element, splide);
    }

    document.addEventListener('initializeSlider', function (e) {
        const {sliderElement, direction} = e.detail;
        initSplideSlider(sliderElement, direction);
    });

    function initSliderOnInteraction(e) {
        e.preventDefault();

        const card = e.currentTarget.closest('.vehicle-card-img');
        if (!card) return;

        let direction = "";
        if (e.currentTarget.classList.contains('splide-prev')) direction = "<";
        if (e.currentTarget.classList.contains('splide-next')) direction = ">";

        const event = new CustomEvent('initializeSlider', {
            detail: {
                sliderElement: card,
                direction: direction
            }
        });

        document.dispatchEvent(event);

        card.removeEventListener('mouseenter', initSliderOnInteraction);
        card.removeEventListener('click', initSliderOnInteraction);
    }

    function registerAdvertSliders() {
        if (matchMedia("(max-width: 600px)").matches) {
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const sliderElement = entry.target;
                        const event = new CustomEvent('initializeSlider', {
                            detail: {sliderElement, direction: ""}
                        });
                        document.dispatchEvent(event);
                        obs.unobserve(sliderElement);
                    }
                });
            }, {
                threshold: 0.5,
            });
            const cards = document.querySelectorAll('.vehicle-card-img');
            cards.forEach(card => observer.observe(card));

            // Force an initial check after DOM is ready
            // This ensures anything already visible gets picked up
            cards.forEach(card => {
                const rect = card.getBoundingClientRect();
                const inView = rect.top < window.innerHeight && rect.bottom > 0;

                if (inView) {
                    const event = new CustomEvent('initializeSlider', {
                        detail: {sliderElement: card, direction: ""}
                    });
                    document.dispatchEvent(event);
                    observer.unobserve(card);
                }
            });
        } else {
            document.querySelectorAll('.vehicle-card-img').forEach(card => {
                card.addEventListener('mouseenter', initSliderOnInteraction, {once: true});
                card.addEventListener('click', initSliderOnInteraction, {once: true});

                const prevBtn = card.querySelector(".splide-prev");
                const nextBtn = card.querySelector(".splide-next");

                if (prevBtn) prevBtn.addEventListener('click', initSliderOnInteraction);
                if (nextBtn) nextBtn.addEventListener('click', initSliderOnInteraction);
            });
        }
    }

    registerAdvertSliders();
    document.registerAdvertSliders = registerAdvertSliders;

    const advertsContainer = document.getElementById('adverts-container');
    if (advertsContainer) {
        const observer = new MutationObserver(function (mutationsList, observer) {
            registerAdvertSliders();
        });

        observer.observe(advertsContainer, {
            childList: true,
            subtree: false,
            characterData: true
        });
    }
});